import { render, staticRenderFns } from "./mbusinessDetail.vue?vue&type=template&id=917ec73a&scoped=true&"
import script from "./mbusinessDetail.vue?vue&type=script&lang=js&"
export * from "./mbusinessDetail.vue?vue&type=script&lang=js&"
import style0 from "./mbusinessDetail.vue?vue&type=style&index=0&id=917ec73a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ec73a",
  null
  
)

export default component.exports